import { LOCATION_CHANGE } from 'connected-react-router';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    isPaymentValid: null,
    defaultPaymentMethodSuccess: null,
    defaultPaymentMethod: null,
    isPaymentSummaryDefaultPaymentMethodSuccess: null,
    paymentSummaryFailed: false,
    isPostCharge: null,
    errorCode: null,
});

const reducer = (state = initState(), action) => {
    switch (action.type) {
        case DispatchConstants.VERIFY_PAYMENT_AND_ACTIVATE_LISTING_SUCCESS:
            return {
                ...state,
                ...(action.payload.paymentSummary),
                paymentSummaryFailed: action.payload.paymentSummaryFailed,
                isPaymentSummaryDefaultPaymentMethodSuccess: action.payload.paymentSummary.defaultPaymentMethodSuccess,
                isPostCharge: action.payload.isPostCharge,
            };
        case DispatchConstants.VERIFY_PAYMENT_AND_ACTIVATE_LISTING_FAIL:
            return {
                ...state,
                ...(action.payload.data.paymentSummary),
                paymentSummaryFailed: action.payload.data.paymentSummaryFailed,
                isPostCharge: action.payload.isPostCharge,
                errorCode: action.payload.code,
            };
        case DispatchConstants.DEFAULT_PAYMENT_SUCCESS:
            return { ...state, defaultPaymentMethod: action.payload, defaultPaymentMethodSuccess: true };
        case DispatchConstants.DEFAULT_PAYMENT_FAIL:
            return { ...state, defaultPaymentMethodSuccess: false };
        case LOCATION_CHANGE:
            return initState();
        default:
    }
    return state;
};

export default reducer;
